module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"qrPreviewTitle":"QR codes from {0}","downloadQRTooltip":"Download","downloadAllQRTooltip":"Download all QRs"},"es":{"qrPreviewTitle":"Códigos QR {0}","downloadQRTooltip":"Descargar","downloadAllQRTooltip":"Descargar todos los QRs"}}')
  delete Component.options._Ctor
}
